var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M24.000,25.898 L20.725,19.115 L20.725,11.602 C20.725,6.983 17.394,3.118 13.116,2.537 L13.116,-0.000 L10.878,-0.000 L10.878,2.537 C6.600,3.118 3.268,6.983 3.268,11.602 L3.268,19.079 L-0.000,25.898 L9.037,25.898 C8.961,26.178 8.920,26.473 8.920,26.777 C8.920,28.554 10.300,30.000 11.997,30.000 C13.694,30.000 15.074,28.554 15.074,26.777 C15.074,26.473 15.033,26.178 14.957,25.898 L24.000,25.898 ZM5.507,19.634 L5.507,19.629 L16.250,19.629 L16.250,17.285 L5.507,17.285 L5.507,11.602 C5.507,7.906 8.375,4.859 11.902,4.805 L12.092,4.805 C15.619,4.859 18.488,7.906 18.488,11.602 L18.488,19.674 L20.361,23.555 L3.628,23.555 L5.507,19.634 ZM12.836,26.777 C12.836,27.262 12.460,27.656 11.997,27.656 C11.534,27.656 11.158,27.262 11.158,26.777 C11.158,26.293 11.534,25.898 11.997,25.898 C12.460,25.898 12.836,26.293 12.836,26.777 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.8c42173e.svg";
export { ForwardRef as ReactComponent };